import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MessageService {
  private subject = new Subject<any>();
  private updateModuleHistory = new Subject<boolean>();

  sendMessage(message: any) {
    this.subject.next(message);
  }

  clearMessage() {
    this.subject.next(null);
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  getModuleHistory(params: boolean) {
    this.updateModuleHistory.next(params);
  }
  setModuleHistory(): Observable<any> {
    return this.updateModuleHistory.asObservable();
  }
}
